import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { TranslatePipe } from '../core/pipes/translate.pipe';
import { Nav } from '../nav/nav';
import { TopHeader } from '../top-header/top-header';

type HelpTab = 'manual' | 'videos' | 'faq';

@Component({
  selector: 'app-help-user-manual',
  standalone: true,
  imports: [CommonModule, Nav, TopHeader, TranslatePipe],
  templateUrl: './help-user-manual.html',
  styleUrls: ['./help-user-manual.css', './../../CSSFiles/Tabs.css'],
})
export class HelpUserManualComponent {
  activeTab: HelpTab = 'manual';
  readonly manualPdfUrl = 'assets/HTally_User_Manual.pdf';
  readonly manualPdfResourceUrl: SafeResourceUrl;

  constructor(private readonly sanitizer: DomSanitizer) {
    this.manualPdfResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.manualPdfUrl);
  }

  selectTab(tab: HelpTab): void {
    this.activeTab = tab;
  }
}
